import { trans } from "@/service/i18n/i18n";
import { Badge } from "@/components/ui/badge";
import { videoCardBadgeStyles } from "@/components/video/video-card/service";
import { cn } from "@/lib/utils";
import {
  getVideoLength,
  isBeforeWeekAgo,
} from "@/components/video/video-card/components/service";

export const PlaylistEpisodePreset = ({
  data,
  active,
}: {
  data: PlaylistEpisodePreviewVM;
  active: boolean;
}) => {
  const { duration, episodeNumber, publishedAt, currentTime } = data;
  return (
    <>
      {!active ? (
        <>
          <Badge
            className={cn(
              videoCardBadgeStyles,
              "right-3 bottom-3 bg-black text-white",
            )}
          >
            {getVideoLength(duration ?? 0)}
          </Badge>
          {episodeNumber == -1 ? (
            <>
              {publishedAt && !isBeforeWeekAgo(publishedAt) && (
                <Badge
                  className={cn(
                    videoCardBadgeStyles,
                    "bg-remedium-blue top-3 left-3 text-white",
                  )}
                >
                  NOWOŚĆ
                </Badge>
              )}
            </>
          ) : (
            <Badge
              className={cn(
                videoCardBadgeStyles,
                "top-3 left-3 bg-black text-white",
              )}
            >
              {trans("education.video.part")} {episodeNumber}
            </Badge>
          )}
        </>
      ) : (
        <Badge
          className={cn(
            videoCardBadgeStyles,
            "bg-remedium-blue top-3 left-3 animate-[pulsatingBlueOutline_2s_ease-in-out_infinite] text-white outline-[3px]",
          )}
        >
          {trans("education.video.now")}
        </Badge>
      )}
      {currentTime != null && currentTime > 0 && (
        <div
          className={"absolute bottom-0 left-0 z-1 h-1 bg-red-500"}
          style={{
            width: `${(currentTime / (duration as number)) * 100}%`,
          }}
        ></div>
      )}
    </>
  );
};
